/**
 * @generated SignedSource<<9b4c5c9916bd16d0f638b4f760648119>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutSidebarSidemarkForm_transaction$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "CheckoutSidebarSidemarkForm_transaction";
};
export type CheckoutSidebarSidemarkForm_transaction$key = {
  readonly " $data"?: CheckoutSidebarSidemarkForm_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSidebarSidemarkForm_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutSidebarSidemarkForm_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "c5fdfcd3804b36a3495f53ce49d0422b";

export default node;
